import React, { Component } from "react";
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {toastr} from "react-redux-toastr";
import { Loader } from "../Common/Loader";
import {
    renderTextInputField,
    renderEmailInputField,
    renderTextField,
    renderSelectField
} from '../Layout/FormInputs'
import { setIncentiveData } from '../../actions/UserAction';
import {langs} from '../../config/localization';
import {required, maxLength30, maxLength100} from '../../validation';
import {eventTracking} from "../../actions/UserAction";
import {focusOnError} from "../../utils";

class IncentiveRegistration extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            showLoader: false
        };
    }

    /**
     * Set contactus data
     * @param values
     */
    onSubmit(values){
        this.setState({showLoader : true});

        values.name = String.prototype.trim.call(values.name);
        values.email = String.prototype.trim.call(values.email);
        values.title = String.prototype.trim.call(values.title);
        values.url = String.prototype.trim.call(values.url);
        values.description = String.prototype.trim.call(values.description);

        //Call the set incentive data action
        this.props.setIncentiveData(values, (response)=>{
            this.setState({showLoader : false});
            if(response.status === 200){
                toastr.success(langs.success, langs.messages.incentive_successfully);
                setTimeout(function(){
                    var win = window.open('https://www.oceanfdn.org/donate/earthdecksorg-ocean-network', '_blank');
                    if(win) {
                        win.focus();
                    }
                    window.location.reload();
                }, 1000);
            }else {
                toastr.error(langs.error, langs.messages.default_error);
            }
        });
    }

    render() {
        const {handleSubmit} = this.props;
        return (
            <div className="row">
                <div className="medium-12 columns">
                    <div className="section-registration">
                        <div className="row">
                            <form noValidate className="form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                <div className="medium-12 columns">
                                    <div className="title-container">
                                        <h2>Entry Form</h2>
                                    </div>
                                    <div className="row">
                                        <div className="medium-6 columns">
                                            <div className="form-group">
                                                <Field
                                                    name="name"
                                                    component={renderTextInputField}
                                                    maxLength="30"
                                                    placeholder="Name of Nominee or Organization*"
                                                />
                                            </div>
                                        </div>
                                        <div className="medium-6 columns">
                                            <div className="form-group">
                                                <Field
                                                    name="email"
                                                    maxLength="100"
                                                    component={renderEmailInputField}
                                                    placeholder="Email of Person to Contact*"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="medium-12 columns">
                                            <div className="form-group">
                                                <Field
                                                    name="title"
                                                    component={renderTextInputField}
                                                    placeholder="Title of Project or Story being Nominated*"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="medium-12 columns">
                                            <div className="form-group">
                                                <Field
                                                    name="url"
                                                    component={renderTextInputField}
                                                    placeholder="Url of Project or Organization being Nominated*"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="medium-12 columns">
                                            <div className="form-group">
                                                <Field
                                                    className="description"
                                                    name="description"
                                                    component={renderTextField}
                                                    placeholder="Brief Description of the Project or Story (250 Words)*"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="medium-12 columns">
                                            <div className="form-group submit-container">
                                                <button type="submit" className="btn-primary primary-gradient-bg">
                                                    <span>Submit</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};

    if(!values.name){
        errors.name = langs.validation_messages.fullname_required;
    }

    if (values.name && values.name.length > 30){
        errors.name = langs.validation_messages.fullname_pattern;
    }

    if(!values.email){
        errors.email = langs.validation_messages.email_required;
    }

    if(values.email && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(values.email) == false){
        errors.email = langs.validation_messages.email_pattern;
    }

    if(!values.title){
        errors.title = langs.validation_messages.title_required;
    }

    if(!values.url){
        errors.url = langs.validation_messages.url_required;
    }

    if(!values.description){
        errors.description = langs.validation_messages.description_required;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: 'IncentiveRegistration',
    onSubmitFail: (errors) => {
        focusOnError(errors)
    }
})(
    connect(null, {setIncentiveData, eventTracking})(IncentiveRegistration)
);



// WEBPACK FOOTER //
// ./components/Incentive/Registration.js